export var lang = {
    salesOfficer: 'Sales Person',
    distributorLocation: 'Shipping Address',
};
